import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { PHONE, WHATSAPP_URL, BRAND, BRAND_LATIN, CITY, keywords, services } from "../lib/data";

export default function Footer() {
    return (
        <footer className="relative bg-[#0a0a0a] text-white overflow-hidden" data-testid="footer">
            <div className="absolute inset-0 opacity-30 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full blur-3xl" style={{ background: "radial-gradient(circle, #c9a961, transparent 60%)" }} />
                <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full blur-3xl" style={{ background: "radial-gradient(circle, #e8c86a, transparent 60%)" }} />
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-16">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 border-b border-[rgba(201,169,97,0.2)] pb-12">
                    <div className="lg:col-span-1">
                        <div className="flex items-center gap-3 mb-5">
                            <div className="icon-orbit relative w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "radial-gradient(circle at 30% 30%, rgba(255,248,214,0.15), rgba(10,10,10,0.6) 60%)" }}>
                                <Logo size={40} />
                            </div>
                            <div>
                                <div className="font-display text-2xl">{BRAND}</div>
                                <div className="font-latin text-[10px] tracking-[0.3em] text-[#c9a961]">{BRAND_LATIN}</div>
                            </div>
                        </div>
                        <p className="text-white/70 text-sm leading-relaxed">
                            الرائدون في جلي وتلميع الرخام بمنطقة عسير و{CITY}. خبرة تفوق العقد ونتائج تلمسها بعينك.
                        </p>
                    </div>

                    <div>
                        <div className="eyebrow mb-4">الخدمات</div>
                        <ul className="space-y-2.5 text-sm">
                            {services.map((s) => (
                                <li key={s.id}>
                                    <Link to={`/services#${s.id}`} className="text-white/75 hover:text-[#e8c86a] transition" data-testid={`footer-service-${s.id}`}>
                                        {s.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <div className="eyebrow mb-4">روابط سريعة</div>
                        <ul className="space-y-2.5 text-sm">
                            <li><Link to="/" className="text-white/75 hover:text-[#e8c86a] transition">الرئيسية</Link></li>
                            <li><Link to="/services" className="text-white/75 hover:text-[#e8c86a] transition">الخدمات</Link></li>
                            <li><Link to="/about" className="text-white/75 hover:text-[#e8c86a] transition">من نحن</Link></li>
                            <li><Link to="/contact" className="text-white/75 hover:text-[#e8c86a] transition">اتصل بنا</Link></li>
                        </ul>
                    </div>

                    <div>
                        <div className="eyebrow mb-4">تواصل معنا</div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li className="flex items-center gap-3">
                                <i className="fa-solid fa-location-dot text-[#c9a961]" />
                                <span>{CITY}، منطقة عسير - المملكة العربية السعودية</span>
                            </li>
                            <li>
                                <a href={`tel:${PHONE}`} className="flex items-center gap-3 hover:text-[#e8c86a]" data-testid="footer-phone">
                                    <i className="fa-solid fa-phone text-[#c9a961]" />
                                    <span dir="ltr">{PHONE}</span>
                                </a>
                            </li>
                            <li>
                                <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[#e8c86a]" data-testid="footer-whatsapp">
                                    <i className="fa-brands fa-whatsapp text-[#c9a961]" />
                                    <span>واتساب مباشر</span>
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                <i className="fa-solid fa-clock text-[#c9a961]" />
                                <span>مفتوح 24 ساعة - طوال الأسبوع</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="py-8 border-b border-[rgba(201,169,97,0.15)]">
                    <div className="eyebrow mb-3 text-center">كلمات مفتاحية</div>
                    <div className="flex flex-wrap gap-2 justify-center text-xs text-white/45" data-testid="footer-keywords">
                        {keywords.map((k, i) => (
                            <span key={i} className="px-2 py-1 rounded-full border border-[rgba(201,169,97,0.15)] hover:text-[#c9a961] hover:border-[rgba(201,169,97,0.4)] transition">
                                {k}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
                    <div>© {new Date().getFullYear()} {BRAND} — جميع الحقوق محفوظة</div>
                    <div className="flex items-center gap-4">
                        <span>صُنع بحرفية عالية</span>
                        <span className="text-[#c9a961]">◆</span>
                        <span>{CITY} - المملكة العربية السعودية</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
